export const SUBSCRIBE = 'SUBSCRIBE';
export const SET_SUBSCRIPTION_EMAIL = 'SET_SUBSCRIPTION_EMAIL';
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS';
